import React, { useLayoutEffect } from 'react';

import PropTypes from 'prop-types';

import Immutable from 'immutable';

import { connect } from 'react-redux';

import { MANUAL_VOUCHER_PAYMENT_PATH } from '../../../../config/paths';

import {
  breadcrumbsPropTypes,
  matchPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

import Loader from '../../../common/Loader';

import Content from '../../../layout/Content';

import NoDataResource from '../../../common/resource/NoDataResource';

import Alert from '../../../common/informative/Alert';

import ManualVoucherPaymentEditForm from './ManualVoucherPaymentEditForm';

import {
  clearManualVoucherPayment,
  getManualVoucherPayment,
  putManualVoucherPayment,
} from '../../../../actions/corporate/ManualVoucherPayment';

export const EditManualVoucherPayment = ({
  match: {
    params: { id: manualVoucherPaymentId },
  },
  dispatchGetManualVoucherPayment,
  breadcrumbs,
  manualVoucherPayment,
  loading,
  dispatchPutManualVoucherPayment,
  dispatchClearManualVoucherPayment,
}) => {
  useLayoutEffect(() => {
    dispatchGetManualVoucherPayment({
      manualVoucherPaymentId,
    });

    return () => dispatchClearManualVoucherPayment();
  }, []);

  const onSubmit = (formValues) => {
    const manualVoucherPaymentJson = manualVoucherPayment.toJS();

    const newFormValues = {
      ...formValues,

      id: manualVoucherPaymentJson.id,

      bankAccountId: formValues.bankAccountId.value,

      manualVoucherId: manualVoucherPaymentJson.manualVoucherId,

      businessId: manualVoucherPaymentJson.businessId,

      customerId: manualVoucherPaymentJson.customerId,
    };

    dispatchPutManualVoucherPayment(manualVoucherPaymentId, newFormValues);
  };

  const generateInitialValues = (manualVoucherPaymentJson) => {
    const { bankAccount } = manualVoucherPaymentJson;

    const currencyMap = {
      PEN: 'Soles',
      USD: 'Dólares',
      EUR: 'Euros',
    };

    const currencyName =
      currencyMap[bankAccount.currency] || bankAccount.currency;

    const receiptLabel = bankAccount.receipt ? ` - ${bankAccount.receipt}` : '';

    return {
      bankAccountId: {
        value: bankAccount.id,
        label: `${bankAccount.bank.name} - ${bankAccount.accountNumber} (${currencyName}) ${receiptLabel} - CCI: ${bankAccount.interbankNumber}`,
      },

      operationNumber: manualVoucherPaymentJson.operationNumber,

      amount: manualVoucherPaymentJson.amount,

      depositDate: manualVoucherPaymentJson.depositDate,
    };
  };

  let content = null;

  if (loading) {
    content = <Loader />;
  } else if (manualVoucherPayment.isEmpty()) {
    content = <NoDataResource returnPage={MANUAL_VOUCHER_PAYMENT_PATH} />;
  } else {
    const manualVoucherPaymentJson = manualVoucherPayment.toJS();

    if (manualVoucherPaymentJson.approved) {
      content = (
        <Alert
          message="No se puede editar un pago de comprobante manual aprobado."
          type="warning"
        />
      );
    } else {
      content = (
        <ManualVoucherPaymentEditForm
          onSubmit={onSubmit}
          initialValues={generateInitialValues(manualVoucherPaymentJson)}
        />
      );
    }
  }

  return (
    <Content
      breadcrumbs={breadcrumbs}
      title="Editar Pago de Comprobante Manual"
      subtitle="Edita la información del pago"
      content={content}
    />
  );
};

const mapStateToProps = (
  { CorporateUnit },
  {
    match: {
      params: { id },
    },
  },
) => ({
  breadcrumbs: [
    ...CorporateUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Lista de Pagos de Voucher Manual',
      href: MANUAL_VOUCHER_PAYMENT_PATH,
    },
    {
      text: 'Ver',
      href: `${MANUAL_VOUCHER_PAYMENT_PATH}/${id}`,
    },
    {
      text: 'Editar',
      href: '',
    },
  ],

  manualVoucherPayment: CorporateUnit.ManualVoucherPayment.getIn([
    'current',
    'content',
  ]),

  loading: !CorporateUnit.ManualVoucherPayment.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const mapDispatchToProps = {
  dispatchGetManualVoucherPayment: getManualVoucherPayment,
  dispatchClearManualVoucherPayment: clearManualVoucherPayment,
  dispatchPutManualVoucherPayment: putManualVoucherPayment,
};

EditManualVoucherPayment.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  dispatchPutManualVoucherPayment: PropTypes.func.isRequired,
  dispatchGetManualVoucherPayment: PropTypes.func.isRequired,
  dispatchClearManualVoucherPayment: PropTypes.func.isRequired,
  match: matchPropTypes.isRequired,
  manualVoucherPayment: PropTypes.instanceOf(Immutable.Map).isRequired,
  loading: PropTypes.bool,
};

EditManualVoucherPayment.defaultProps = {
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EditManualVoucherPayment);
